import { ref, set } from 'vue'
import { batchEnableAutoAcquistionModify } from '@/api/convert.model'
import { EMPTY_VALUE } from '../consts/index.js'

export function useBatchSubmit(props, emit, { getTableRowClassName, buildBasicParams, tableValidate, resetForm }) {
  const submitFlag = ref(false)
  const errorMsg = ref('')
  const confirmLoading = ref(false)

  const buildParams = (rows) => {
    return rows
      .filter((row) => getTableRowClassName({ row }) === '')
      .filter((row) => row.autoAcquisitionNewBudget !== EMPTY_VALUE)
      .map((row) => {
        return buildBasicParams(row)
      })
  }

  const failedRowRetry = async (row) => {
    const params = {
      task_list: [buildBasicParams(row)]
    }

    set(row, 'retryLoading', true)

    try {
      const data = await batchEnableAutoAcquistionModify(params)
      if (data?.length) {
        const [newRow] = data
        const newList = props.rows.map((r) => {
          if (newRow.planId === r.planId) {
            return {
              ...r,
              retryLoading: false,
              autoAcquisitionResult: {
                ...newRow
              }
            }
          }
          return r
        })

        emit('update:rows', newList)
        emit('refresh')
      }
    } catch (e) {
      set(row, 'retryLoading', false)
    }
  }

  const handleSubmitRequest = (params) => {
    confirmLoading.value = true
    return batchEnableAutoAcquistionModify(params)
      .then((data) => {
        if (data?.length) {
          submitFlag.value = true

          const newList = props.rows.map((row) => {
            const rowResult = data.find((d) => d.planId === row.planId) || {}
            return {
              ...row,
              retryLoading: false,
              autoAcquisitionResult: {
                ...rowResult
              }
            }
          })

          emit('update:rows', newList)
          emit('refresh')
        }
      })
      .finally(() => {
        confirmLoading.value = false
      })
  }

  const onBatchModifyConfirm = () => {
    errorMsg.value = ''
    tableValidate(props.rows)
      .then(() => {
        const params = {
          task_list: buildParams(props.rows)
        }
        handleSubmitRequest(params)
      })
      .catch((e) => {
        const { msg, index } = JSON.parse(e.message) || {}
        if (msg) {
          errorMsg.value = `序号${index + 1}：${msg}`
        }
      })
  }

  const onBatchModifyCancel = () => {
    emit('input', false)
    submitFlag.value = false
    confirmLoading.value = false
    errorMsg.value = ''
    resetForm()
  }

  return {
    submitFlag,
    errorMsg,
    confirmLoading,
    failedRowRetry,
    onBatchModifyConfirm,
    onBatchModifyCancel
  }
}
